<template>
  <div id="container">
    <div class="full_layout">
      <ul class="creditBox" >
        <li v-if="list">
          <div class="credit">
            <!-- <router-link class="el-icon-arrow-left back" :to="{path:'/login'}">Card Hobby</router-link> -->
            <img :src="list.CommodityList[0].GFCommodityBody.Imgs[0]" class="titleImg" />
            <div class="title">
              <p>{{list.CommodityList[0].GFCommodityBody.Title}}</p>
            </div>
            <div class="price">{{list.Currency}} {{list.OrderAmount}}</div>
            <div class="orderCode">{{$t('colon.orderNumber')}} {{list.OrderCode}}</div>
          </div>
        </li>
        <li class="cardInfo">
          <div class="credit">
            <iframe class="iframe" src="../../../static/AuthorizeNetSeal.html"></iframe>
            <div class="titleCard">Accepted Payment Method</div>
            <div class="imglist">
              <img src="../../../static/images/Visa.png" />
              <img src="../../../static/images/Mastercard.png" />
              <img src="../../../static/images/Amex.png" />
              <img src="../../../static/images/Discover.png" />
            </div>
            <div class="titleCard titleC">Card information</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <div class="dateCode">
                <el-form-item class="" label="Frst Name" prop="frstname">
                  <el-input v-model="ruleForm.frstname" placeholder='Frst Name' />
                </el-form-item>
                <el-form-item class="rightCode" label="Last Name" prop="lastname">
                  <el-input v-model="ruleForm.lastname" placeholder='Last Name' />
                </el-form-item>
              </div>
              <el-form-item label="Card Number" prop="cardNumber">
                <el-input v-model="ruleForm.cardNumber" @input="inputCard('card')" placeholder="1234 5678 9012 3456" maxlength="24" />
              </el-form-item>
              <div class="dateCode">
                <el-form-item class="" label="Expiration Date" prop="expiration">
                  <el-input v-model="ruleForm.expiration" @input="inputCard('date')" placeholder='MM/YY' maxlength='5' />
                </el-form-item>
                <el-form-item class="rightCode" label="Authorization Code" prop="code">
                  <el-input v-model="ruleForm.code" placeholder='CVC' maxlength='3' />
                </el-form-item>
              </div>
              <div class="dateCode">
                <el-form-item class="" label="City" prop="city">
                  <el-input v-model="ruleForm.city" placeholder='City' />
                </el-form-item>
                <el-form-item class="rightCode" label="State" prop="state">
                  <el-input v-model="ruleForm.state" placeholder='State' />
                </el-form-item>
              </div>
              <el-form-item label="Email" prop="email">
                <el-input v-model="ruleForm.email" placeholder='Email' />
              </el-form-item>
              <el-button class="text_btn" type="primary" @click="submitForm('ruleForm')">{{$t('base.pay')}}</el-button>
            </el-form>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import { getInfo, numAdd,setUTC,isNumber } from "@/api/public";
import qs from 'qs';
export default {
  name: 'index',
  components: {},
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      userInfo: null,
      orderId: '',
      list: null,
      nowData: new Date().getTime(),
      ruleForm: {
        month:'',
        year:'',
        cardNumberNoSpace:'',
        cardNumber: '', //
        expiration: '', //
        code: '', //
        city: '',
        state: '',
        frstname: '',
        lastname: '',
        email: ''
      },
      rules: {
        frstname: [
          { required: true, message: 'Please enter Frst Name', trigger: 'blur' }
        ],
        lastname: [
          { required: true, message: 'Please enter Last Name', trigger: 'blur' }
        ],
        cardNumber: [
          { required: true, message: 'Your card number is incomplete.', trigger: 'blur' }
        ],
        expiration: [
          { required: true, message: 'Please enter Expiration Date', trigger: 'blur' },
          { validator: this.expirationValidate, trigger: 'blur' }
        ],
        code: [
          { required: true, message: 'Please enter CVC', trigger: 'blur' }
        ],
        city: [
          { required: true, message: 'Please enter your City', trigger: 'blur' }
        ],
        state: [
          { required: true, message: 'Please enter your State', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Please enter your Email', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {},
  mounted() {},
  created() {
     console.log(this.$route, 'this.$route')
    this.orderId = this.$route.query.id;
    this.userInfo = getInfo()
    this.OrdersDetail()
  },
  methods: {
    // 信用卡有效期验证
    expirationValidate(rule, value, callback){
      if(value){
        var msg = "Your data is invalid."
        if(value.length<5){
          callback(new Error(msg));
        }
        if(value.indexOf('/')>-1){
          var exp=value.split('/')
          var month=isNumber(exp[0])
          var year=isNumber(exp[1])
          var time=setUTC(this.nowData, -8, 'cn')
          var timeYear=isNumber(time.getFullYear().toString().substr(2,2));
          var timeMonth=isNumber(time.getMonth())
          if((year-timeYear)>=50){
            msg="Your card's expiration year is invalid."
            callback(new Error(msg));
          }
          if((timeYear>year)||((timeYear==year)&&(timeMonth>month))){
            msg="Your card's expiration vear is in the past."
            callback(new Error(msg));
          }
          callback()
        }else{
          callback(new Error(msg));
        }
        callback()
      }
    },
    // 获取订单详情
    OrdersDetail() {
      let that = this
      let data = { memberid: that.userInfo.MappingUserId, orderId: that.orderId }
      this.$get(this.$interface.GetStoreOrderById, data).then(res => {
        if (res.Result != 0) {
          this.list = res.Data;
        }
      })
    },
    // 信用卡 type card：卡号，date:有效期，cvc:cvc
    inputCard(type) {
      let that = this
      // 信用卡号
      if (type == 'card') {
        //不允许输入非数字字符
        that.ruleForm.cardNumber = that.ruleForm.cardNumber.replace(/[\D]/g, '');
        //4位一组，非获取匹配最后一组数字，避免删除到空格时会马上自动补齐
        that.ruleForm.cardNumber = that.ruleForm.cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
        // 把卡号去除空格赋给cardNumberNoSpace
        that.ruleForm.cardNumberNoSpace = that.ruleForm.cardNumber
        that.ruleForm.cardNumberNoSpace = that.ruleForm.cardNumberNoSpace.replace(/[\s]/g, '');

      }
      //信用卡有效期
      if(type=='date'){
        let expiration=that.ruleForm.expiration
        //不允许输入非数字字符
        that.ruleForm.expiration = expiration.replace(/[^\d/]/g, '');
        if(expiration){
          if(expiration.indexOf('/')>-1){
            if(expiration.length>1){
              expiration=expiration.split("/");
              var month=expiration[0]
              var year=expiration[1]
              if(month.length>0){
                if(month>1&&month<=9&&month.length==1){
                  month=0+month
                  that.ruleForm.month=month
                }else{
                  that.ruleForm.month=month
                }
              }
              if(year.length>0){
                  that.ruleForm.year=year
              }
              that.ruleForm.expiration=month+'/'+year
            }else{
              that.ruleForm.expiration=''
            }
          }else{
            if(expiration>1&&expiration<=9){
              if(expiration.length<2){
                that.ruleForm.month=0+expiration
                that.ruleForm.expiration=0+expiration+'/'
              }
            }else{
              that.ruleForm.expiration=expiration
            }
          }
        }
      }
      // 信用卡cvc
      if(type=='cvc'){
        
      }
    },
    // pay
    submitForm(formName) {
      // this.$router.push({
      //   path: '/payapp?type=paysuccess'
      // })
      // 验证
      this.$refs[formName].validate((valid) => {

      })
    }
  }
}

</script>
<style scoped>
.creditBox {
  display: flex;
  background: #fff;
  height: 100vh;
}

.creditBox>li {
  width: 50%;
}

.creditBox>li+li {
  box-shadow: -1px 0px 3px 0px rgba(0, 0, 0, 0.02), -6px 0px 6px 0px rgba(0, 0, 0, 0.01), -13px 0px 8px 0px rgba(0, 0, 0, 0.01), -23px 0px 9px 0px rgba(0, 0, 0, 0.01), -36px 0px 10px 0px rgba(0, 0, 0, 0.00);
}

.creditBox li .credit {
  width: 380px;
  min-height: 444px;
  margin: 0 auto;
  margin-top: 125px;
}

.creditBox li.cardInfo {
  display: flex;
  align-items: center;
}

.creditBox li.cardInfo .credit {
  margin-top: 0;
}

.credit .titleImg {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
  margin-top: 48px;
}

.credit .title {
  margin-top: 12px;
  min-height: 60px;
}

.credit .price {
  font-size: 36px;
  font-weight: 700;

}

.credit .orderCode {
  color: #a0a0a0;
}

.credit .dateCode {
  display: flex;
}

.credit .text_btn {
  width: 100%;
}

.credit .titleCard {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 15px;
}

.credit .titleC {
  margin-bottom: 0;
}

.imglist {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.imglist img {
  width: 80px;
}

/deep/ .dateCode .el-input__inner {
  border-radius: 4px 0 0 4px;
}

/deep/ .dateCode .rightCode .el-input__inner {
  border-radius: 0 4px 4px 0;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type=number] {
  -moz-appearance: textfield;
}

.iframe {
  position: absolute;
  top: 39px;
  border: none;
  width: 92px;
  height: 75px;
  right: 5vh;
}

@media screen and (max-width:980px) {
  .full_layout {
    width: 100%;
  }

  .creditBox {
    display: block;
    height: auto;
    width: 90%;
    margin: 0 auto;
  }

  .creditBox>li {
    width: 100%;
  }

  .creditBox>li+li {
    box-shadow: none;
  }

  .creditBox li .credit {
    width: 100%;
    height: auto;
    margin-top: 20px;
  }

  .credit .titleImg {
    margin: 48px auto 0;
  }

  .creditBox li.cardInfo {
    margin-bottom: 20px;
  }

  /deep/ .AuthorizeNetSeal {
    top: 22vh;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/creditcard.vue